import React, { useCallback, useRef, useState, useEffect,useMemo } from "react";
import { connect } from "react-redux";
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    RequiredRule,
    StateStoring
} from "devextreme-react/data-grid";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import "jspdf-autotable";
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager"
import { GridLayout } from "../../../common/GridLayout";
const SerialNumberTab = (props) => {
    const dataGrid = useRef(null);
    const gridKey = "2B1FFA69-0D6F-428E-8B4D-4D8FF73520B5";
    var url = "wm/Item/GetSerialNumbers";
    const dataSource = useMemo(() => createStore({
        key: 'Rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
        loadParams:
        {
            id: props.sourceId,
            type : props.type
        },
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.sourceId,
            };
        } 
    }), [props.sourceId]);
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    var accessToken = props.oidc.user.access_token;
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const onContentReady = (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            var selection = e.component.getSelectedRowKeys();
            if (selection.length == 0) {
                e.component.selectRowsByIndexes([0]);
            }
        }
    };
    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
    }
    return (
        <div >
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                id="gridContainer"
                onContentReady={onContentReady}
                dataSource={dataSource}
                ref={dataGrid}
                selectedRowKeys={selectedItemKeys}
                showBorders={true}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onSelectionChanged={handleCellValueChanged}
                height='71vh'
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                  <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling mode="standard" />
                <Selection mode="single" />
                <Export enabled={true} allowExportSelectedData={true} />

                <Paging enabled={true} defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                    showInfo={true}
                />
                <Editing
                    mode="cell"
                    refreshMode="repaint"
                    allowUpdating={true}
                    allowAdding={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <Column  dataField="Serialnumber" caption="Serial #" dataType="string"  allowEditing={false}   />
                <Column  dataField="Lot" caption="Lot" dataType="string"  allowEditing={false}  />
                <Column  dataField="Netweight" caption="Net Weight" dataType="string" allowEditing={false}   />
                <Column  dataField="Grossweight" caption="Gross Weight" dataType="string"  allowEditing={false}  />
                <Column  dataField="Size1" caption="Size 1" dataType="string"  allowEditing={false}  />
                <Column  dataField="Size2" caption="Size 2" dataType="string"  allowEditing={false}  />
                <Column  dataField="Userdefinedreference1" caption="Reference 1" dataType="string"  allowEditing={false}  />
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}
export default connect(mapStateToProps)(SerialNumberTab);